module.exports = new __parcel__URL__("amp.316cbe72.png").toString();